import { Component, OnInit, AfterViewInit } from '@angular/core';
import { User } from 'src/app/models';
import { AuthenticationService } from '../services';
import { Router } from '@angular/router';
import { LoginService } from 'src/app/login/login.service';
import { environment } from 'src/environments/environment.prod';

@Component({
  selector: 'cmp-header',
  templateUrl: './header.component.html',
  styleUrls: [],
  standalone: false
})
export class HeaderComponent implements OnInit {
  public User: User;
  public currentUrl: string;
  public applicantMenuActive = '';
  public flatDetailsMenuActive = '';
  public documentsMenuActive = '';
  public slotBookingMenuActive = '';
  public paymentsMenuActive = '';
  public requestsMenuActive = '';
  public updatesMenuActive = '';
  public historyMenuActive = '';
  public feedsMenuActive = '';
  public contactMenuActive = '';
  public CommunicationMenuActive = '';
  public notifications: boolean;

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private loginService: LoginService
  ) {
    this.User = new User();
  }

  ngOnInit() {
    this.currentUrl = window.location.pathname;
    this.User = this.authService.getUserInfo();

    if (this.currentUrl === '/flat-details') {
      this.flatDetailsMenuActive = 'active open';
    }

    if (this.currentUrl === '/applicant-details') {
      this.applicantMenuActive = 'active open';
    }

    if (
      this.currentUrl === '/documents'
    ) {
      this.documentsMenuActive = 'active open';
    }

    if (this.currentUrl === '/slot-booking') {
      this.slotBookingMenuActive = 'active open'
    }

    if (this.currentUrl === '/payment-milestones') {
      this.paymentsMenuActive = 'active open';
    }
    if (this.currentUrl === '/requests') {
      this.requestsMenuActive = 'active open';
    }

    if (this.currentUrl === '/updates') {
      this.updatesMenuActive = 'active open';
    }

    if (this.currentUrl === '/payment-history') {
      this.historyMenuActive = 'active open';
    }
    if (this.currentUrl === '/feeds') {
      this.feedsMenuActive = 'active open';
    }
    if (this.currentUrl === '/contact') {
      this.contactMenuActive = 'active open';
    }
    if (this.currentUrl === '/customer-communication') {
      this.CommunicationMenuActive = 'active open';
    }
  }

  public logout(): void {
    this.authService.logoutUser(this.router);
  }
}
